import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import { useTranslation } from 'react-i18next';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "../../redux/supervisorSlice";
import { selectionTypes } from "../utils/consts";
import { DataGrid, Column, ColumnChooser, StateStoring, Sorting, SearchPanel, Scrolling } from 'devextreme-react/data-grid';
import { seconds2HMS } from "../utils/utils";
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import ChannelIcon from "../chat/channelIcon";
import WidgetTools from "./widgetTools";
import TransferButton from "./queuedcallsdetail/transferbutton";
import ChatService from "src/services/chatservice";
import { Button } from 'react-bootstrap';
import LiveChat from "../chat/livechat";
import Toastr from "../utils/toastr";
import TransferModal from "../agents/transfermodal";

const TransferButtonRenderer = React.memo(({ data }) => {
    return <TransferButton call={data} type={"message"} />;
});

const ChannelIconRenderer = React.memo(({ channel }) => {
    return <ChannelIcon channel={channel} type={"message"} />;
});

const GridRenderer = React.memo(({ dataSource, rtl, viewChatCell, transferChatCell }) => {

    const { t } = useTranslation();

    return (<DataGrid
        id="queuedchatstable"
        dataSource={dataSource}
        showBorders={false}
        columnAutoWidth={true}
        width={"100%"}
        height={"99%"}
        allowColumnResizing={true}
        repaintChangesOnly={true}
        loadPanel={{ enabled: false }}
        rtlEnabled={rtl}
    >
        <SearchPanel
            visible={true}
            width={240}
            placeholder={t("search")}
        />

        <Sorting mode={"single"} />
        <Scrolling mode="virtual" />
        <StateStoring
            enabled={true}
            type="localStorage"
            storageKey={`queuedchatsdetail`}
        />
        <Column dataField="id" visible={false} showInColumnChooser={false} />
        <Column cssClass={"align-middle"} dataField="transfer" caption={""} showInColumnChooser={false} width={60} cellRender={transferChatCell} />
        <Column dataField="channel" caption={t("channel")} width={"10%"} cellRender={chn => <ChannelIconRenderer channel={chn.value} />} alignment="center" />
        <Column cssClass={"align-middle"} dataField="text" caption={t("message")} visible={true} width={200} />
        <Column cssClass={"align-middle"} dataField="queueDate" caption={t("queuedate")} dataType={"datetime"} visible={true} width={100} />
        <Column cssClass={"align-middle"} dataField="from" caption={t("from")} visible={true} width={200} />
        <Column cssClass={"align-middle"} dataField="groupName" caption={t("group")} visible={true} width={100} />
        <Column cssClass={"align-middle"} dataField="waitingTime" caption={t("waitingtime")} visible={true} width={100} />
        <Column cssClass={"align-middle"} dataField="requestDateTime" caption={t("requestdatetime")} visible={true} width={100} dataType={"datetime"}/>
        <Column dataField="guid" caption={""} width={10} cellRender={viewChatCell} alignment="center" />
        <ColumnChooser enabled={true} mode={"select"} allowSearch={true} />

    </DataGrid>);
});

function QueuedChatsDetail(props) {

    const dataSource = useMemo(() => new DataSource({
        store: new ArrayStore({
            key: "guid",
            data: []
        }),
        reshapeOnPush: true
    }), []);


    const { t } = useTranslation();
    const [showSettings, setShowSettings] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [channel, setChannel] = useState(localStorage.getItem(`QueuedChats_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`QueuedChats_channelName_${props.identifier}_user${props.id}`) || "");
    const [chat, setChat] = useState(null);
    const [showLiveChat, setshowLiveChat] = useState(false);
    const [showTransferModal, setShowTransferModal] = useState(false);

    const toastrRef = useRef(null);
    const lastUpdate = useRef(new Date());
    lastUpdate.current.setMinutes(lastUpdate.current.getMinutes() - 1);
    const queuedCountRef = useRef(null);

    const chatClick = (guid) => {
        ChatService.getChat(guid, res => {
            if (res?.data?.guid) {
                setChat(res.data);
                toggleLiveChat();
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            }
        });
    }

    const viewChatCell = useCallback((dataCell) => {
        let ret = <></>;
        if (dataCell.value)
            ret = <Button key={dataCell.value} variant="light-primary" size='sm' onClick={e => chatClick(dataCell.value)}><FontAwesomeIcon icon={duotone('eye')} /></Button>
        return ret;
    }, [chatClick]);

    const toggleLiveChat = () => {
        setshowLiveChat(!showLiveChat);
    }

    const toggleChatTransfer = () => {
        setShowTransferModal(!showTransferModal);
    }

    const chatTransfer = (chat) => {
        ChatService.getChat(chat.data.guid, res => {
            if (res?.data?.guid) {
                setChat(res.data);
                toggleChatTransfer();
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("error"));
                toastrRef.current.show();
            }
        });
    }

    const transferChatCell = (dataCell) => {

        return <Button variant='light-primary' size='sm'
            onClick={e => {
                chatTransfer(dataCell)
            }
            }>
            <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} />
        </Button>
    }
    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/queuedchats", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("queuedchats");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {

    //     if(props.activeWidget !== props.id){
    //         setShowSettings(false);
    //     }
    //     return () => {
    //     };
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [props.activeWidget, props.id]);

    useEffect(() => {

        if (props.connected) {

            let groupsStr = localStorage.getItem(`QueuedChats_groups_${props.identifier}_user${props.id}`) || "[]";
            let groups = JSON.parse(groupsStr);
            setSelectedGroups(selectedGroups);

            MonitorWSService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
                token: props.token,
                groupsIds: groups
            }));

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/queuedchats/`, (message) => {
                updateState(message).catch(err => {
                    console.error("Failed to process message:", err);
                });
            }, { id: "queuedchats" });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroupsAndChannel = (groups, channel, channelName) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`QueuedChats_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));

        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`QueuedChats_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`QueuedChats_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups
        }));

    };


    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }



    const updateState = useCallback(async (chats) => {
        const now = new Date();
        const diff = now - lastUpdate.current;
        if (!document.hidden && diff > 1000) {
            var data = JSON.parse(chats.body);
            var chn = localStorage.getItem(`QueuedChats_channel_${props.identifier}_user${props.id}`);

            if (chn !== null && chn !== "") {
                chn = chn === "chat" ? "fidelity" : chn;
                data = data.filter(x => x.channel.toLowerCase() === chn.toLowerCase());
            }

            data.forEach(v => {
                var queueDate = new Date();
                queueDate.setSeconds(queueDate.getSeconds() - v.timeWaiting);
                queueDate.setMilliseconds(1);
                var diff = v.timeWaiting;
                v.queueDate = queueDate;

                v.waitingTime = seconds2HMS(diff);
            });

            let callIds = dataSource.store()._array.map(x => x.guid);
            const changes = [];

            callIds.forEach(x => {
                if (data.map(c => c.guid).indexOf(x) === -1) {
                    changes.push({ type: 'remove', key: x });
                }
            });

            data.forEach(v => {
                if (callIds.indexOf(v.guid) > -1) {
                    changes.push({ type: 'update', key: v.guid, data: v });
                } else {
                    changes.push({ type: 'insert', data: v });
                }
            });

            if (changes?.length > 0) {
                dataSource.store().push(changes);
            }

            lastUpdate.current = new Date();
            if (queuedCountRef.current) {
                queuedCountRef.current.innerText = data.length;
            }
        }
    }, []);

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"}>
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("message-plus")} /> {t("chatsqueuedetail")} <span className="badge badge-light-primary fs-base" ref={queuedCountRef}>0</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ padding: "0px", height: "360px" }} >
                <GridRenderer dataSource={dataSource} rtl={props.rtl} viewChatCell={viewChatCell} transferChatCell={transferChatCell} />
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} activeWidget={props.activeWidget} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupsAndChannel={setGroupsAndChannel} selectedGroups={selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE} channel={channel} channelName={channelName}></WidgetSettings>
            {
                chat !== null &&
                <LiveChat show={showLiveChat} toggleModal={toggleLiveChat} chat={chat} agent={props.agent} ></LiveChat>
            }
            <Toastr ref={toastrRef} />
            <TransferModal show={showTransferModal} toggleModal={toggleChatTransfer} chat={chat}></TransferModal>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
    };
};

export default connect(mapStateToProps, { removeWidget })(QueuedChatsDetail);